import React from "react"
import PropTypes from "prop-types"

import FindSearchInput from "../FindSearchInput"
import LocatedInSearchInput from "../LocatedInSearchInput"
import OwnedBySearchInput from "../OwnedBySearchInput"
import SubmitButton from "../SubmitButton"
import MobileSearchBar from "./MobileSearchBar"
import "./SearchBar.scss"

class SearchBar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      keywords: this.props.keywords,
      unitId: this.props.unitId,
      departmentId: this.props.departmentId,
    }
  }

  searchTerms = () => ({
    keywords: this.state.keywords,
    unitId: this.state.unitId,
    departmentId: this.state.departmentId,
  })

  updateKeywords = (keywords, runSearch) => {
    this.setState({ keywords }, () => {
      runSearch && this.search()
    })
    /* istanbul ignore next */
    if (window.gtag !== undefined) {
      /* istanbul ignore next */
      window.gtag("event", "SearchQuery", {
        category: "SearchQuery",
        action: "findSearchQuery",
        label: keywords,
      })
    }
  }

  updateLocation = unitId => {
    this.setState({ unitId }, this.search)
    /* istanbul ignore next */
    if (window.gtag !== undefined) {
      /* istanbul ignore next */
      window.gtag("event", "SearchQuery", {
        category: "SearchQuery",
        action: "findSearchQuery",
        label: unitId,
      })
    }
  }

  updateOwnedBy = departmentId => {
    this.setState({ departmentId }, this.search)
    /* istanbul ignore next */
    if (window.gtag !== undefined) {
      /* istanbul ignore next */
      window.gtag("event", "SearchQuery", {
        category: "SearchQuery",
        action: "findSearchQuery",
        label: departmentId,
      })
    }
  }

  search = () => {
    this.props.redirect && this.props.redirect()
    const searchTerms = this.searchTerms() // must pull out searchTerms before running onSearchMode()
    this.props.deviceType === "mobile" && this.props.onSearchMode()
    this.props.runSearch(searchTerms)
  }

  onSubmitButtonClick = () => {
    this.updateKeywords(this.state.keywords, true)
  }

  render() {
    // MOBILE
    if (this.props.deviceType === "mobile") {
      return (
        <MobileSearchBar
          isExpanded={!!this.props.redirect}
          updateKeywords={this.updateKeywords}
          updateLocation={this.updateLocation}
          updateOwnedBy={this.updateOwnedBy}
          onSubmitButtonClick={this.onSubmitButtonClick}
          searchTerms={this.searchTerms({})}
          allAssets={this.props.allAssets}
          units={this.props.units}
          departments={this.props.departments}
          onSearchMode={this.props.onSearchMode}
          searchMode={this.props.searchMode}
          searchView={this.props.searchView}
        />
      )
    }

    // DESKTOP AND TABLET
    return (
      <div className="search-bar-container">
        <div className="SearchBar">
          {this.props.deviceType === "desktop" && this.props.searchView ? (
            <div className="title-and-icon">
              <div className="title">Asset Locator</div>
              <div className="icon">
                <img alt="AssetTracking Logo" src="/icons/ATLogo.svg" />
              </div>
            </div>
          ) : null}

          <div className="search-form">
            <FindSearchInput
              allAssets={this.props.allAssets}
              keywords={this.state.keywords}
              updateKeywords={this.updateKeywords}
              searchOnEmptyInput={this.props.searchOnEmptyInput}
            />
            <div className="input-divider" />
            <LocatedInSearchInput
              units={this.props.units}
              updateLocation={this.updateLocation}
              unitId={this.state.unitId}
            />
            <div className="input-divider" />
            <OwnedBySearchInput
              departments={this.props.departments}
              updateOwnedBy={this.updateOwnedBy}
              departmentId={this.state.departmentId}
            />
            <SubmitButton onClick={this.onSubmitButtonClick} />
          </div>
        </div>
      </div>
    )
  }
}

SearchBar.propTypes = {
  deviceType: PropTypes.string.isRequired,
  runSearch: PropTypes.func.isRequired,
  redirect: PropTypes.func,
  searchView: PropTypes.bool,
  allAssets: PropTypes.array.isRequired,
  keywords: PropTypes.string,
  unitId: PropTypes.string,
  departmentId: PropTypes.string,
  units: LocatedInSearchInput.propTypes.units,
  departments: OwnedBySearchInput.propTypes.departments,
  onSearchMode: PropTypes.func,
  searchMode: PropTypes.bool,
  searchOnEmptyInput: PropTypes.bool,
}

SearchBar.defaultProps = {
  allAssets: [],
  keywords: "",
  unitId: "",
  departmentId: "",
}

export default SearchBar
